import { jsxs as o, jsx as r } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...a,
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          fill: "currentColor",
          d: "M22.063 35.973a2.5 2.5 0 0 1-2.497-2.497 2.5 2.5 0 0 1 2.497-2.497 2.5 2.5 0 0 1 2.497 2.497 2.5 2.5 0 0 1-2.497 2.497ZM41.936 35.973a2.5 2.5 0 0 1-2.497-2.497 2.5 2.5 0 0 1 2.497-2.497 2.5 2.5 0 0 1 2.497 2.497 2.5 2.5 0 0 1-2.497 2.497ZM25.866 27.367a4 4 0 0 1-3.996-3.995 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 3.999 3.999 0 0 1-3.996 3.995ZM37.856 27.367a4 4 0 0 1-3.996-3.995 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 3.999 3.999 0 0 1-3.996 3.995ZM31.946 44.92a4 4 0 0 1-3.996-3.995 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 3.999 3.999 0 0 1-3.996 3.995Z"
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          fill: "currentColor",
          d: "M31.999 13.627c10.229 0 18.521 8.292 18.521 18.52s-8.292 18.521-18.521 18.521c-10.229 0-18.52-8.292-18.52-18.521 0-10.229 8.292-18.52 18.52-18.52Zm0-3.996a22.444 22.444 0 0 0-15.921 6.595 22.428 22.428 0 0 0-4.824 7.156 22.367 22.367 0 0 0-1.771 8.765c0 3.037.596 5.987 1.771 8.765a22.428 22.428 0 0 0 4.824 7.156 22.428 22.428 0 0 0 7.156 4.824 22.385 22.385 0 0 0 8.765 1.771 22.444 22.444 0 0 0 15.921-6.595 22.428 22.428 0 0 0 4.824-7.156 22.367 22.367 0 0 0 1.771-8.765c0-3.037-.596-5.987-1.771-8.765a22.428 22.428 0 0 0-4.824-7.156 22.428 22.428 0 0 0-7.156-4.824 22.385 22.385 0 0 0-8.765-1.771Z"
        }
      )
    ]
  }
);
export {
  t as ChargerType1
};
